import { Box, Paper, Stack, Typography } from '@mui/material';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

export default function CleanupInfoPanel({ title, description, action, children }) {
  const hasHeader = Boolean(title) || Boolean(action);

  return (
    <Paper sx={{ p: 3, ...viewRootTextPrimarySx }} elevation={2}>
      <Stack spacing={2}>
        {hasHeader ? (
          <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={2}>
            {title ? <Typography variant='h6'>{title}</Typography> : <Box />}
            {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
          </Stack>
        ) : null}
        {description ? (
          <Typography variant='body2' color='text.secondary'>
            {description}
          </Typography>
        ) : null}
        {children}
      </Stack>
    </Paper>
  );
}
